import React from 'react';

import iconThankYou from '_images/carousell-sq-icon-thank-you.svg';

const LeadPageFinishForm = () => {
  return (
    <div className="lead-page-form opacity-95 lg:opacity-100 transition-opacity flex justify-center items-center">
      <div className="text-center">
        <img
          className="ml-auto mr-auto"
          alt="Your request had been registered!"
          width="128"
          height="128"
          src={iconThankYou}
        />
        <h4 className="os-text-24 font-bold mt-8">Thank you!</h4>
        <p className="os-text-17 mt-4">
          Our car experts will be in touch with you{' '}
          <br className="hidden md:block" />
          within 3 business days to assist you!
        </p>
      </div>
    </div>
  );
};
export default LeadPageFinishForm;
